import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { getTaskFieldMetadata } from './constants';
import { AutoSaverFormItem } from './AutoSaverFormItem';
import { useTask } from './Provider';
import { StageTaskType } from '@/store/Lifecycle/constants';

export const EnumField = observer(() => {
  const task = useTask<StageTaskType.Enum>();
  const {
    name,
    value,
    options = [],
    validateStatus,
    help,
    isSaving,
    validValues,
    isReadOnly,
    required,
  } = getTaskFieldMetadata(task);
  const { t } = useTranslation();

  const validValuesString = validValues
    ? `, ${t('Valid values')}: ${validValues?.map(value => t(value)).join(', ')}`
    : '';
  const helpText = help ? `${t(help)}${validValuesString}` : isSaving ? t('Saving...') : undefined;

  return (
    <AutoSaverFormItem
      name={name}
      initialValue={value}
      className="stage-task-input-field"
      validateStatus={validateStatus}
      help={helpText}
      required={required}
      saveOnChange
    >
      <Radio.Group
        className="stage-task-input"
        defaultValue={options[0]?.value}
        value={value}
        options={options.map(({ name, value }, i) => ({
          value,
          label: t(name || value),
          className: `stage-task-enum-option stage-task-enum-option-${i + 1}`,
          style: {
            flex: 1,
          },
        }))}
        optionType="button"
        buttonStyle="solid"
        size="large"
        disabled={isReadOnly || isSaving}
      />
    </AutoSaverFormItem>
  );
});
